import React, { useEffect } from 'react';
import clsx from 'clsx';

import { ClickableIcon, ClickableIconProps } from '../ClickableIcon';
import { IconSize } from '../Icon/iconSize';
import { HeaderHamburger, HeaderHamburgerProps } from './HeaderHamburger';
import { DivPropsWithoutRef } from '../../common/types';
import { deprecateProp } from '@hse-design/core';

export interface HeaderProps extends Omit<DivPropsWithoutRef, 'title'> {
  /**
   * Заголовок
   */
  title?: React.ReactNode;
  /**
   * Компонент иконки логотипа
   */
  logoIcon?: React.ElementType;
  /**
   * Обработчик клика по логотипу
   */
  onLogoClick?: ClickableIconProps<'button'>['onClick'];
  /**
   * Обработчик клика по гамбургер-меню
   * @deprecated Передавайте элемент HeaderHamburger через слот right
   */
  onHamburgerClick?: HeaderHamburgerProps['onClick'];
  /**
   * Слот слева
   */
  prepend?: React.ReactNode;
  /**
   * Слот для логотипа
   */
  logo?: React.ReactNode;
  /**
   * Слот для меню или заголовка
   * Для меню рекомендуется использовать компоненты HeaderMenu и HeaderLink
   */
  left?: React.ReactNode;
  /**
   * Слот для кнопок авторизации, логотипа пользователя
   */
  right?: React.ReactNode;
  /**
   * Кастомные классы:
   * logo – контейнер логотипа
   * left – левая часть компонента
   * right – правая часть компонента
   */
  classes?: {
    logo?: string;
    left?: string;
    right?: string;
  };
}

export const Header: React.FC<HeaderProps> = ({
  title,
  onLogoClick,
  prepend,
  logo,
  logoIcon,
  left,
  right,
  className,
  onHamburgerClick,
  classes,
  ...props
}) => {
  useEffect(() => {
    if (onHamburgerClick)
      deprecateProp(
        'onHamburgerClick',
        'Передайте HeaderHamburger в слот right',
        Header
      );
  }, [onHamburgerClick]);
  return (
    <div className={clsx('hse-Header', className)} {...props}>
      {prepend}
      <div className={clsx('hse-Header__logo', classes?.logo)}>
        {logo
          ? logo
          : !!logoIcon && (
              <ClickableIcon
                iconProps={{ icon: logoIcon, size: IconSize.large }}
                onClick={onLogoClick}
              />
            )}
      </div>
      <div className={clsx('hse-Header__left', classes?.left)}>
        {left ? left : <div className="hse-Header__title">{title}</div>}
      </div>
      <div className={clsx('hse-Header__right', classes?.right)}>
        {right !== undefined ? (
          right
        ) : (
          <HeaderHamburger onClick={onHamburgerClick} />
        )}
      </div>
    </div>
  );
};
